import { useEffect, useState } from "react";
import ReactPlayerDefaultImport, { type ReactPlayerProps } from "react-player";

// react-player's CJS build fakes an ESM default export (it sets its own
// `__esModule` flag and a `default` getter). Vite's dependency
// pre-bundler re-exports that whole CJS module object as this chunk's
// default instead of unwrapping it, so the default import above is
// sometimes the module object rather than the player class -- unwrap it
// defensively so this keeps working whichever shape we get.
const Player =
  (
    ReactPlayerDefaultImport as unknown as {
      default?: typeof ReactPlayerDefaultImport;
    }
  ).default ?? ReactPlayerDefaultImport;

export function ReactPlayerThrowsOnError(props: ReactPlayerProps) {
  const [error, setError] = useState<Error>();

  useEffect(function effectResetErrorOnUnmount() {
    return () => {
      setError(undefined);
    };
  }, []);

  if (error) {
    throw error;
  }

  return (
    <Player
      {...props}
      onError={(error) => {
        try {
          setError(new Error(JSON.stringify(error)));
        } catch {
          setError(new Error(error?.message ?? "React Player Error"));
        }
      }}
    />
  );
}
